import styled from 'styled-components';
import {ColumnFlexBox} from '@/styled-components';
import {Z_INDEX} from '@/styles';
import {AiPromptButton} from './AiPrompt';
import {CadastralButton} from './CadastralButton';
import {NearbyCategoryButton, NearbyInfoButton} from './Nearby';
import {RulerButton} from './RulerButton';
import {StarredBrandButton} from './StarredBrandButton';
import {StreetViewButton} from './StreetViewButton';
import {ButtonGroup} from './StyledComponents';
import {WatchPositionController} from './WatchPositionController';
import {ZoomController} from './ZoomController';

export interface ToolboxItemProps {
  isFirstItem?: boolean;
  isLastItem?: boolean;
}

export const Toolbox = () => {
  return (
    <Root>
      <Inner>
        <ColumnFlexBox gap={12}>
          <ButtonGroup>
            <StreetViewButton isFirstItem />
            <CadastralButton />
            <RulerButton isLastItem />
          </ButtonGroup>
          <AiPromptButton />
        </ColumnFlexBox>
        <ButtonGroup>
          <StarredBrandButton isFirstItem />
          <NearbyCategoryButton />
          <NearbyInfoButton isLastItem />
        </ButtonGroup>
        <ButtonGroup>
          <WatchPositionController isFirstItem />
          <ZoomController isLastItem />
        </ButtonGroup>
      </Inner>
    </Root>
  );
};

const Root = styled.div`
  position: absolute;
  right: 16px;
  top: 16px;
  bottom: 120px;
  z-index: ${Z_INDEX.mapFloating};
  display: flex;
  pointer-events: none;
`;

const Inner = styled.div`
  position: relative;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
